(function ($) {
  $(document).ready(function() {
    $('.paragraph--type--accordion .field--name-field-titulo').click(function() {
      $(this).toggleClass('active');
      $(this).next('.field--name-field-body').slideToggle();
    });
  });
})(jQuery);
